import { SearchspringFetcher } from '../classes/searchspring-fetcher'
import { normaliseResults } from '../helpers/normalisers'
import { generateSearchspringProvider } from './provider'

export class SearchspringCollection extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { handle, originalQuery, sort, filters, page, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('bgfilter.collection_handle', handle)

    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    if (sort) this.params.setSort(sort)
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export const SearchspringCollectionProvider = generateSearchspringProvider(SearchspringCollection, (results) => {
  return {
    ...results,
    results: normaliseResults(results.results)
  }
})
